export { default } from '@/components/SmartOdometerCapture';
